// url parameters used for automated communications feature
export const AUTOMATED_COMMS_URL_PARAMS = {
  comm_title: "comm_title", // used on the edit communication page to retrieve target communication details
  comm_info: "comm_info", // communication info string displayed in the edit communication page header
  listing_uuid: "listing_uuid", // uuid of the targeted listing communication used in the edit communication page
  category: "category", // target offering type category, used in the edit communication page when changing WhatsApp templates (fetches templates for the selected offering category)
  tab: "tab", // currently opened tab
};
